import React from 'react';
import ProfileComponent from '../components/Profile/ProfileComponent';

const Profile = () => {
    return <ProfileComponent />
}

export default Profile;